export const capitalize = (str) =>
  str ? str.trim().replace(/\b\w/g, (c) => c.toUpperCase()) : "";

export const fmtCurrency = (amount, currency = "EUR") => {
  if (amount == null) return "—";
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
};
